module.exports = __webpack_public_path__ + "img/gas-pump.23919161.svg";